import "../../assets/css/carousel.scss";
import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import PartnerApplyStatic from "../common/PartnerApplyStatic";

// Public "/Partners" page. The hero, benefits strip and application form
// are rendered by the shared, dark-themed PartnerApplyStatic component
// (see components/common/PartnerApplyStatic), which posts submissions to
// POST /contact-form (type: 'partner').
function PartnersPage() {
  return (
    <div className="App">
      <Header />
      <PartnerApplyStatic />
      <Footer />
    </div>
  );
}

export default PartnersPage;
